import styled from "styled-components";

const DashboardStatisticsStyles = styled.section`
  margin-bottom: 20px;
  width: 100%;
`;

export default DashboardStatisticsStyles;
